import AppInfo, { AppInfoProps } from './AppInfo';

export type { AppInfoProps };
export default AppInfo;
